module.exports = __webpack_public_path__ + "static/media/marnie-icon.80ed5c4e.png";